import React, {useEffect} from 'react'
import { Box } from '@mui/system'
import Sidebar from './sidebar'
import {  Button, TextField } from '@mui/material';

import { DataGrid } from '@mui/x-data-grid';
import CustomToolbar from './CustomToolbarPrint';
import { useNavigate } from 'react-router-dom';


import { collection, query, getDocs } from "firebase/firestore"; 
import {db} from "../firebase.js";

import "../App.css"


function SearchHeader ({Heading, data, setFilter, backupData}){


    const [row ,setRows] = React.useState([]);
    const [backupRow, setBackupRows] = React.useState([]);
    const [firstNameSearch, setFirstNameSearch] = React.useState("");
    const [surnameSearch, setSurnameSearch] = React.useState("");
    const [contactSearch, setContactSearch] = React.useState("");
    const [dobSearch, setDobSearch] = React.useState("");

   React.useEffect(() => {
      setRows(data);
    setBackupRows(backupData);
   })
   


    let filterResults = () => {
    
        let newArray = backupRow.filter(function (el) {
          const firstNameMatch = !firstNameSearch || (el.firstName && el.firstName.toLowerCase().includes(firstNameSearch.toLowerCase()));
          const surnameMatch = !surnameSearch || (el.surName && el.surName.toLowerCase().includes(surnameSearch.toLowerCase()));
          const contactMatch = !contactSearch || (el.contact && el.contact.toLowerCase().includes(contactSearch.toLowerCase()));
          const dobMatch = !dobSearch || (el.DOB && el.DOB.toLowerCase().includes(dobSearch.toLowerCase()));
          
          return firstNameMatch && surnameMatch && contactMatch && dobMatch;
        }
        );
        setRows(newArray);
        setFilter(newArray);
      }


  return (
    <div className="Head-Search">
            <h1>
              {}
            </h1>
            <div style={{ width: "70vw", display: "flex", gap: "10px" }}>
              <TextField
                style={{ width: "300px" }}
                label="Search by First Name"
                variant="outlined"
                value={firstNameSearch}
                onChange={(e) => setFirstNameSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by Surname"
                variant="outlined"
                value={surnameSearch}
                onChange={(e) => setSurnameSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by Contact Number"
                variant="outlined"
                value={contactSearch}
                onChange={(e) => setContactSearch(e.target.value)}
              />
              <TextField
                style={{ width: "300px" }}
                label="Search by DOB"
                variant="outlined"
                value={dobSearch}
                onChange={(e) => setDobSearch(e.target.value)}
              />
              <Button onClick={filterResults}> Search </Button>
              <Button onClick={()=>{
                setFirstNameSearch("");
                setSurnameSearch("");
                setContactSearch("");
                setDobSearch("");
                setRows(backupRow);
                setFilter(backupRow);
              }}> Reset </Button>
            </div>
          </div>
  )

}


export default function ViewAll() {
    const [rows, setRows] = React.useState([])
    const [backupRow, setBackupRows] = React.useState([]);

    let arr = [];
  
    useEffect( () => {
      test()
  
      async function test(){
        arr=[]
        getData()
      }
  
      setRows(arr)
      setBackupRows(arr);
      console.log(arr)
  
  }, []);
  
  async function getData (){
    console.log("me chala")
    let arr = []
    const q = query(collection(db, "employee"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  

     arr.sort((a, b) => {
      return a.surName.localeCompare(b.surName);
    });
  
     setRows(arr)
     setBackupRows(arr);
  
  }
  
  
  
    const navigate = useNavigate();
    const columns = [
      //{ field: 'id', headerName: 'ID', width: 70 },
      { field: 'firstName', headerName: 'Name', width: 150 },
      { field: 'surName', headerName: 'Surname', width: 150 },
      //{ field: 'lastName', headerName: 'Last Name', width: 150 },
      // {
      //   field: 'age',
      //   headerName: 'Age',
      //   type: 'number',
      // },
      {
          field: 'startDate',
          headerName: 'Start Date',
          // type: 'number',
          width: 170 
          
        },
        { field: 'contact', headerName: 'Contact Number' , width: 150 },
        { field: 'postCode', headerName: 'Post Code' , width: 150 },
        { field: 'DOB', headerName: 'Date of Birth' , width: 150 },
        // {
        //   field: "action",
        //   headerName: "",
        //   sortable: false,
        //   renderCell: (params) => {
        //     const onClick = (e) => {
             
              
        //       navigate("/profile");
        //     };
      
        //     return <Button onClick={onClick} style={{color: "#1c3261"}}>View Details</Button>;
        //   }
        // },
        
    
      
    ];
  
    const handleRowClick = (params) => {
      //console.log(params.row);
      navigate("/profile",{
        state: {
          employee: params.row,
          activeStep: 0,
        }
      });
    };
    
    return (
  
        
  
        <Box sx={{ display: 'flex' }}>
          <Sidebar />
       
         
          <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{marginTop: "50px", justifyContent: "center", alignItems: "center"}}>
         
          <div style={{ height: 640, width: '100%'}}>

          <SearchHeader Heading="All Beneficiary" data={rows} backupData={backupRow} setFilter={(e) => setRows(e)} />
              <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[5]}
                  //checkboxSelection
                  onRowDoubleClick={handleRowClick}
                  components={{
                    Toolbar: CustomToolbar,
                  }}
              />
          </div>
          
        </Box>
       
          
      </Box>
  
      
    )
}
